import React, {Component} from "react";
import CoverImg from "../../../images/stadium.jpg";

class BoxDesc extends Component{

    constructor(props){
        super(props);
        this.state = {
            
        }
    }

    render(){
        return(
            <React.Fragment>
                <div className="desc-widget">
                    <img src={CoverImg} />
                    <div className="cover-info">
                        <h3>DRAGONKART</h3>
                        <p className="sec-txt small-txt">Hincubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.</p>
                        <div className="social-flex cover-flex">
                            <i className="fab fa-facebook-square"></i>
                            <i className="fab fa-twitter"></i>
                            <i className="fab fa-whatsapp"></i>
                            <i className="fab fa-linkedin"></i>
                        </div>
                    </div>
                </div>

                <div className="abt-desc">
                    <h3>DragonKart Box  Arata</h3>
                    <p className="sec-txt small-txt">Hincubated pools are the most exclusive pools on our platform. They give you early access to projects as an investor at public IDO stage and are usually exclusive to LIGHT holders only.</p>
                </div>
            </React.Fragment>
        );
    }
}

export default BoxDesc;
